import { render, staticRenderFns } from "./BubbleLoader.vue?vue&type=template&id=72e7088a&scoped=true&"
import script from "./BubbleLoader.vue?vue&type=script&lang=js&"
export * from "./BubbleLoader.vue?vue&type=script&lang=js&"
import style0 from "./BubbleLoader.vue?vue&type=style&index=0&id=72e7088a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7088a",
  null
  
)

export default component.exports